module.exports = "https://static.im-cdn.com/mjc/storefront/Ikkat/static/media/toastClose.28786b20.svg";